import axios from "axios";
import router from "@/router";
import User from "@/models/user";

const getDefaultState = () => {
  return {
    loginInfo: "",
    fields: {
      USER_PERMISSIONS: `
        brand
        
        customer_create
        customer_show
        customers_index
        customer_block_streatus
        customer_set_web_app_id

        inquiries_index
        inquiry_create
        inquiry_create_master
        inquiry_show
        inquiry_edit_price
        inquiry_hard_delete
        
        invoices_index
        invoice_paid
        invoice_pause
        invoice_resume
        invoice_exact_import
        invoice_exact_export
        invoice_resend
        invoice_edit_note

        order_create
        order_show
        orders_index
        order_complete
        order_terminate
        order_add_connectivity
        order_cancel
        order_item_quantity_edit
        order_add_device
        order_add_item
        order_uncomplete_delete
        order_item_price_edit
        order_note_edit

        order_service_index
        order_service_tab
        order_service_create_replace
        order_service_create_install
        order_service_create_remove
        order_service_edit_request_replace
        order_service_edit_request_install
        order_service_edit_request_remove

        permissions_edit
        permissions_show
        permissions_index
        
        price_list_edit
        price_list_show
        price_list_index

        credit_create

        device_actions
        devices_index
        device_transfer

        installations_index
        installation_request

        kpi_devices
        kpi_finance
        super_admin
      
        import_tool
        create_device_event
        create_device_event_custom_agent
        synatec_orders_index
        synatec_order_create
        synatec_order_edit
        synatec_order_request
        manage_synatec_products
        customers_merge
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getLoginInfo(state) {
    return state.loginInfo;
  }
};

const actions = {
  login({ commit, rootGetters, state }, payload) {
    commit("setLoginInfo", "");

    let data = JSON.stringify({
      user: {
        email: payload.email,
        password: payload.password
      }
    });
    commit("setShowLoadingModal", true, { root: true });
    axios
      .post(rootGetters.getLoginUrl, data, {
        headers: { "Content-Type": "application/json" }
      })
      .then(res => {
        let user = new User();

        // If bad pasword or something errors look like this for example:
        // success: false, errors: {password: ["Verkeerde email of wachtwoord"]}, reference: null}
        if (!res.data.success) {
          let errors = res.data.errors;
          let errorDesc = "";
          for (let key in errors) {
            errorDesc += errors[key] + " ";
          }

          // Show error message
          throw new Error(errorDesc);
        }


        user.token = res.data.access_token.access_token;
        user.name = res.data.user.name;
        user.email = res.data.user.email;
        user.locale = res.data.user.locale;

        commit("setUser", user, { root: true });

        localStorage.setItem("user", JSON.stringify(user));

        let data = {
          query: `mutation {
            UserAuthenticate {
              user_permissions { ${state.fields.USER_PERMISSIONS} }
            }
          }
        `
        };

        return axios.post(rootGetters.getGraphQlUrl, data, {
          headers: {
            Authentication: `Token token=${res.data.access_token.access_token}`,
            timeout: true
          }
        });
      })
      .then(res => {
        let user = JSON.parse(localStorage.getItem("user"));
        user.permissions = res.data.data.UserAuthenticate.user_permissions;

        commit("setUser", user, { root: true });
        localStorage.setItem("user", JSON.stringify(user));
        commit("setShowSystemModal", true, { root: true });

        router.push({ name: "dashboard" });
      })
      .catch(err => {
        console.error(err);

        commit("setLoginInfo", err.message);
      })
      .then(() => {
        commit("setShowLoadingModal", false, { root: true });
      });
  },
  logOut({ commit }) {
    commit("setUser", new User(), { root: true });
    localStorage.removeItem("user");
    router.push({ name: "login" });
    //location.reload();
  }
};

const mutations = {
  setLoginInfo(state, value) {
    state.loginInfo = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
